export default class mainElement{
    constructor(id=0, parent_id=0, position='', visibility=true, name='', text='', value='', isDefault=false,
        image='', imageLeft='',imageRight='', imageSupport='', imageSupportRight='', imageSupportLeft='', imageSurface='', field_type='',
        numRows=0, numCols=0, validationSelectedOptions=[], growingChildDirection='', childs=[]){

    /*constructor(id, parent_id, position, visibility, name, text, value, isDefault,
        image, imageSupport, imageSupportRight, imageSupportLeft, imageSurface, field_type,
        numRows, numCols, validationSelectedOptions, growingChildDirection, childs){*/
                    
        this.id = id;
        this.parent_id = parent_id;
        this.position = position;
        this.visibility = visibility;
        this.name = name;
        this.text = text;
        this.value = value;
        this.isDefault = isDefault;
        this.image = image;  
        this.imageLeft = imageLeft;        
        this.imageRight = imageRight;
        this.imageSupport = imageSupport;
        this.imageSupportRight = imageSupportRight;
        this.imageSupportLeft = imageSupportLeft; 
        this.imageSurface = imageSurface; 
        this.field_type = field_type; //radio, radioSubItem, dropdown, dropdownSubItem, label, subComponentARepetir, mainComponent, textbox
        this.numRows = numRows;
        this.numCols = numCols;
        this.validationSelectedOptions = validationSelectedOptions; //2compart_60x150, 2compart_60x200, ....
        this.growingChildDirection = growingChildDirection; //up, down, left, right

        this.childs = childs;

    }
}